import { builder } from '@builder.io/react';

import Page, {
  getStaticPaths as originalGetStaticPath,
  getStaticProps as originalGetStaticProps,
} from 'pages/pages/p/[page]';

import config from '../../config';

builder.init(config.builderApiKey);

export default Page;

export const getStaticProps = originalGetStaticProps;
export const getStaticPaths = originalGetStaticPath;
